// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3ENCH","dragIcon":"Choice_dragIcon__UOqDA","left":"Choice_left__3t1aE","input":"Choice_input__vj0eN"};